export const componentsMixin = {
	methods: {
		// toast 提示
		showToast (txt, time) {
			const toast = this.$createToast({
				txt,
				time,
				type: 'txt'
			})
			toast.show()
		},
		// 防抖
		debounce (fn, timeInterval) {
			if (this.timer) {
				clearTimeout(this.timer)
			}
			let arg = [ ...arguments ].filter((item, index) => {
				return index > 1
			})
			this.timer = setTimeout(() => {
				fn.apply(this, arg)
			}, timeInterval)
		},
		// 函数节流
		throttle (fn, gapTime) {
			let _lastTime = null
			return function () {
				let _nowTime = +new Date()
				if (_nowTime - _lastTime > gapTime || !_lastTime) {
					fn()
					_lastTime = _nowTime
				}
			}
		},
		// alert 弹窗提示
		showAlert (content, confirm) {
			this.$createDialog({
				type: 'alert',
				content,
				confirmBtn: confirm,
			}).show()
		}
	}
}
